import React from 'react'

const Error = () => {
  return (
    <div className="h-[80vh] w-100% flex flex-col align-middle justify-center items-center">
    <img
      src="https://i.ibb.co/1KnkFYQ/Group-20-2.png"
      className="w-[100%] sm:h-[85%] h-[50%]"
    />
  </div>
  )
}

export default Error
